import { Injectable } from '@angular/core';

export interface FormInstanceListCollapseState {
  NeedsChanges: boolean;
  Draft: boolean;
  Open: boolean;
  PendingApproval: boolean;
  PendingDirectorApproval: boolean;
  Rejected: boolean;
  Completed: boolean;
}

export type FormInstanceListType = keyof FormInstanceListCollapseState;

@Injectable()
export class CollapseStateService {
  private defaultPreferences: FormInstanceListCollapseState = {
    NeedsChanges: false,
    Draft: false,
    Open: false,
    PendingApproval: false,
    PendingDirectorApproval: false,
    Rejected: false,
    Completed: false,
  };
  private _storageKey: string | null = null;

  private getStorageKey(agreementId: number) {
    if (!this._storageKey) {
      this._storageKey = `_collapse_form_instance_list_agreement_${agreementId}`;
    }
    return this._storageKey;
  }

  public getPreferences(agreementId: number) {
    const key = this.getStorageKey(agreementId);
    const savedPreferences = localStorage.getItem(key);
    if (savedPreferences) {
      return JSON.parse(savedPreferences);
    } else {
      localStorage.setItem(key, JSON.stringify(this.defaultPreferences));
      return this.defaultPreferences;
    }
  }

  public setPreferences(agreementId: number, itemListType: FormInstanceListType, value: boolean) {
    const storageKey = this.getStorageKey(agreementId);
    const preferences = this.getPreferences(agreementId);
    preferences[itemListType] = value;
    localStorage.setItem(storageKey, JSON.stringify(preferences));
  }
}
